import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { Modal } from "./Brands";

const empty = { name: "", floor: "", status: "active" };

export default function Locations() {
  const [items, setItems] = useState([]);
  const [floors, setFloors] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/locations").then((r) => setItems(r.data));
  useEffect(() => { load(); api.get("/floors").then(r => setFloors(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (modal === "new") await api.post("/locations", form);
    else await api.patch(`/locations/${modal}`, form);
    setModal(null); load();
  };

  return (
    <Layout title="Locations" subtitle="Touchpoints"
      action={<button className="btn-dark flex items-center gap-2" onClick={() => { setForm(empty); setModal("new"); }} data-testid="add-location-btn"><Plus size={14} /> Add location</button>}>
      <div className="card-sharp">
        <table className="fin">
          <thead><tr><th>Name</th><th>Floor</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id} data-testid={`location-row-${l.id}`}>
                <td className="font-medium">{l.name}</td>
                <td className="text-[#595959]">{l.floor || l.zone || "—"}</td>
                <td><span className={`badge badge-${l.status}`}>{l.status}</span></td>
                <td className="text-right">
                  <button className="btn-outline mr-2" style={{padding:"6px 10px"}} onClick={() => { setForm({ name: l.name, floor: l.floor || l.zone || "", status: l.status }); setModal(l.id); }}><Edit2 size={12} /></button>
                  <button className="btn-outline" style={{padding:"6px 10px"}} onClick={async () => { if (confirm("Delete?")) { await api.delete(`/locations/${l.id}`); load(); } }}><Trash2 size={12} /></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="4" className="text-center py-8 text-[#8C8C8C]">No locations.</td></tr>}
          </tbody>
        </table>
      </div>
      {modal && (
        <Modal onClose={() => setModal(null)} title={modal === "new" ? "Add location" : "Edit location"}>
          <form onSubmit={save} className="space-y-4">
            <div><div className="label-tiny mb-1.5">Name</div><input className="fin" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="loc-name" /></div>
            <div>
              <div className="label-tiny mb-1.5">Floor</div>
              <select className="fin" value={form.floor||""} onChange={(e) => setForm({...form, floor: e.target.value})} data-testid="loc-floor">
                <option value="">— select floor —</option>
                {floors.filter(f => f.status === "active").map(f => <option key={f.id} value={f.name}>{f.name}</option>)}
              </select>
            </div>
            <div><div className="label-tiny mb-1.5">Status</div>
              <select className="fin" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                <option value="active">Active</option><option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn-dark" data-testid="save-location-btn">Save</button>
            </div>
          </form>
        </Modal>
      )}
    </Layout>
  );
}
